import { Box, Typography, Grid } from "@mui/material";
import data from "../../Assets/data/members.json";

const MembersSection = () => {
  const MemberCard = (props) => {
    return (
      <>
        <Grid
          container
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={3}
            style={{
              backgroundImage: props.image
                ? `url(${
                    process.env.PUBLIC_URL + "/Images/ProfilePic/" + props.image
                  })`
                : `url(${
                    process.env.PUBLIC_URL + "/Images/placeholderProfile.png"
                  })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              width: "120px",
              height: "120px",
              borderRadius: "120px",
              border: "2px solid #000000",
            }}
          />
          <Grid
            item
            xs={9}
            style={{ padding: "16px", boxSizing: "border-box" }}
          >
            <Typography fontWeight={600} fontSize="20px">
              {props.name}
            </Typography>
            <Typography>{props.title}</Typography>
            <Typography fontSize="12px">{props.introduction}</Typography>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              Research Group Members
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container style={{ marginTop: "48px" }}>
              <Grid xs={12} item>
                <Typography fontWeight={600} fontSize="28px">
                  Members
                </Typography>
              </Grid>
              {data.map((member, i) => {
                return member.role === "member" ? (
                  <Grid item xs={6} key={i}>
                    <MemberCard {...member} />
                  </Grid>
                ) : null;
              })}
              <Grid xs={12} item>
                <Typography fontWeight={600} fontSize="28px">
                  Alumni
                </Typography>
              </Grid>
              {data.map((member, i) => {
                return member.role === "alumni" ? (
                  <Grid item xs={6} key={i}>
                    <MemberCard {...member} />
                  </Grid>
                ) : null;
              })}
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default MembersSection;
